import Axios from "axios";
import MODE  from '../config.js';
const MODE_URL = {
    local: 'https://localhost:4000',
    staging: 'http://staging.fusioncharts.net:4001',
    release: 'https://www.fusioncharts.com/dashboards/api/shipment-analysis-db'
}
const server = {
    get : (uri, options) => {
        return Axios.get(MODE_URL[MODE['CURR-MODE']]+uri, options);
    }
}

export default server;


// WEBPACK FOOTER //
// ./src/util/apiService.js